module.exports = __webpack_public_path__ + "static/img/stay-option-icon-sofabed.89edb4f8.svg";